import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import DownloadIcon from '@mui/icons-material/Download';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import CopyAllIcon from '@mui/icons-material/CopyAll';

interface ImageActionsProps {
  onDelete?: () => void;
  onSendToDevice?: () => void;
  onDownload?: () => void;
  onDuplicate?: () => void;
  onCopyToClipboard?: () => void;
  show: boolean;
  showDelete?: boolean;
  showSendToDevice?: boolean;
  showDownload?: boolean;
  showDuplicate?: boolean;
  showCopyToClipboard?: boolean;
}

export const ImageActions: React.FC<ImageActionsProps> = ({
  onDelete,
  onSendToDevice,
  onDownload,
  onDuplicate,
  onCopyToClipboard,
  show,
  showDelete = true,
  showSendToDevice = true,
  showDownload = false,
  showDuplicate = true,
  showCopyToClipboard = false,
}) => {
  if (!show) return null;

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 12,
        right: 12,
        display: 'flex',
        gap: '6px',
        opacity: 0,
        transition: 'opacity 0.2s ease',
        zIndex: 10,
        '.image-container:hover &, .video-container:hover &': {
          opacity: 1,
        },
      }}
    >
      {showSendToDevice && onSendToDevice && (
        <Tooltip title="Send to Device" placement="top">
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              onSendToDevice();
            }}
            size="small"
            sx={{
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              color: 'white',
              '&:hover': {
                backgroundColor: 'rgba(59, 130, 246, 0.7)',
                borderColor: 'rgba(59, 130, 246, 0.5)',
              },
              transition: 'all 0.2s ease',
              padding: '8px',
            }}
          >
            <PhoneIphoneIcon sx={{ fontSize: '18px' }} />
          </IconButton>
        </Tooltip>
      )}

      {showDownload && onDownload && (
        <Tooltip title="Download" placement="top">
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              onDownload();
            }}
            size="small"
            sx={{
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              color: 'white',
              '&:hover': {
                backgroundColor: 'rgba(59, 130, 246, 0.7)',
                borderColor: 'rgba(59, 130, 246, 0.5)',
              },
              transition: 'all 0.2s ease',
              padding: '8px',
            }}
          >
            <DownloadIcon sx={{ fontSize: '18px' }} />
          </IconButton>
        </Tooltip>
      )}

      {showCopyToClipboard && onCopyToClipboard && (
        <Tooltip title="Copy to Clipboard" placement="top">
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              onCopyToClipboard();
            }}
            size="small"
            sx={{
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              color: 'white',
              '&:hover': {
                backgroundColor: 'rgba(59, 130, 246, 0.7)',
                borderColor: 'rgba(59, 130, 246, 0.5)',
              },
              transition: 'all 0.2s ease',
              padding: '8px',
            }}
          >
            <ContentPasteIcon sx={{ fontSize: '18px' }} />
          </IconButton>
        </Tooltip>
      )}

      {showDuplicate && onDuplicate && (
        <Tooltip title="Duplicate" placement="top">
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              onDuplicate();
            }}
            size="small"
            sx={{
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              color: 'white',
              '&:hover': {
                backgroundColor: 'rgba(124, 58, 237, 0.7)',
                borderColor: 'rgba(124, 58, 237, 0.5)',
              },
              transition: 'all 0.2s ease',
              padding: '8px',
            }}
          >
            <CopyAllIcon sx={{ fontSize: '18px' }} />
          </IconButton>
        </Tooltip>
      )}
      
      {showDelete && onDelete && (
        <Tooltip title="Delete" placement="top">
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              onDelete();
            }}
            size="small"
            sx={{
              backgroundColor: 'rgba(220, 38, 38, 0.6)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              color: 'white',
              '&:hover': {
                backgroundColor: 'rgba(220, 38, 38, 0.9)',
                borderColor: 'rgba(220, 38, 38, 0.7)',
              },
              transition: 'all 0.2s ease',
              padding: '8px',
            }}
          >
            <DeleteIcon sx={{ fontSize: '18px' }} />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
};
